import { NamedProperty, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useMasterLookupsApi } from "../../api/master-api/lookups/useMasterLookupsApi";
import { LookupDataProvidersQueryKey } from "./LookupDataProvidersQueryKey";

export type AspectRatio = NamedProperty;

export const useAspectRatios = (): SprintQueryResult<AspectRatio[]> => {
    const { getAspectRatios } = useMasterLookupsApi();

    return useSprintQuery<AspectRatio[]>({
        queryKey: [LookupDataProvidersQueryKey.AspectRatios],
        queryFn: async (): Promise<AspectRatio[]> => {
            const response = await getAspectRatios();
            return response.items;
        }
    });
};
